/**
 *  HsxCrmWeb
 *  <p>
 * Created by 徐智军 on 09-05-0005.
 */
import axios from "axios";
import router from "../router";
import { getToken, getType } from "../utils/auth";
import store from "../store";
import qs from "querystring";
import Vue from "vue";

export function bindUrl(path, pathParams) {
  if (!path.match(/^\//)) {
    path = "/" + path;
  }
  let url = path;
  url = url.replace(/\{([\w-]+)\}/g, function(fullMatch, key) {
    let value;
    if (pathParams.hasOwnProperty(key)) {
      value = pathParams[key];
    } else {
      value = fullMatch;
    }
    return encodeURIComponent(value);
  });
  return url;
}

function getCacheKey(config) {
  return config.url + "?" + qs.stringify(config.params);
}

function setCache(config, data) {
  let cacheAge = config.cacheAge || 60 * 5 * 1000;
  const key = getCacheKey(config);
  Vue.ls.set(key, data, cacheAge);
}

function getCache(config) {
  const key = getCacheKey(config);
  let data = Vue.ls.get(key);
  if (data) {
    data.__cache = true;
  }
  return data;
}

axios.interceptors.request.use(
  request => {
    // let uid = getUID()
    let token = getToken();
    let type = getType();
    // if (!!uid) {
    //     config.headers.uid = uid;
    // }
    request.headers["Tenant-Id"] = "000000";
    // request.headers["User-Type"] = "user";
    if(!request.headers["Authorization"]){
      request.headers["Authorization"] = "Basic b2lsX2FwcDpkUklhVEU=";
    }
    request.headers["User-Type"] = type;
    request.headers["Gateway-Type"] = type;
    if (token) {
      // request.headers.token = token + "";
      // request.headers.Authorization = "Bearer " + token + "";
      request.headers["Blade-Auth"] = token;
    }
    if (request.method === "get" && request.cache) {
      const data = getCache(request);
      if (data) {
        // console.log("getCache", data);
        request.adapter = () => {
          return Promise.resolve({
            data,
            status: request.status,
            statusText: request.statusText,
            headers: request.headers,
            config: request,
            request: request
          });
        };
      }
    }
    return request;
  },
  err => {
    return Promise.reject(err);
  }
);
axios.interceptors.response.use(
  response => {
    if (response.config.cache && !response.data.__cache) {
      // console.log("setCache", response.data);
      setCache(response.config, response.data);
    }
    return response.data;
  },
  error => {
    if (error.response.status === 401) {
      if (error.response.data.error_description) {
        console.log("");
      } else {
        loginProcessor();
      }
      // loginProcessor();
      return;
    }
    if (error.response.data.code == 38600) {
      return Promise.reject(error.response.data);
    }
    if (error.response.data.code == 41110) {
      return Promise.reject(error.response.data);
    }
    if (
      error.response.data.code == 14208 ||
      error.response.data.code == 14207
    ) {
      return Promise.reject(error.response.data);
    }
    return Promise.reject(
      error.response.data.msg || error.response.data.error_description
    );
  }
);

// let toLoginDialogShowing = false

let loginProcessor = function() {
  store.dispatch("logout").then(() => {});
  let path = window.location.pathname + window.location.search;
  router.push({ name: "WechatAuth", query: { redirect: path } });
};

export function mapXResult(data, returnData = false) {
  // 重新登录处理
  if (data.code) {
    if (data.code === 200) {
      return Promise.resolve(returnData ? data : data.data);
    } else {
      if (data.code !== undefined && data.code === 401) {
        if (typeof loginProcessor === "function") {
          loginProcessor();
        }
        return Promise.reject(new Error("需要登录"));
      }
      return Promise.reject({
        data,
        toString() {
          return data.msg;
        }
      });
    }
  } else {
    return Promise.resolve(data);
  }

  // if (data.status === 200) {
  //   return Promise.resolve(returnData ? data : data.data);
  // } else {
  //   if (data.status !== undefined && data.status === 401) {
  //     if (typeof loginProcessor === "function") {
  //       loginProcessor();
  //     }
  //     return Promise.reject(new Error("需要登录"));
  //   }
  //   return Promise.reject({
  //     data,
  //     toString() {
  //       return data.msg;
  //     }
  //   });
  // }
}

export function checkResultMap(check = true) {
  return function(data) {
    if (check) {
      return mapXResult(data);
    } else {
      return Promise.resolve(data);
    }
  };
}

export const request = axios;

export default {
  buildUrl(url) {
    return url;
  },

  setProcessor(processor) {
    loginProcessor = processor;
  },

  /**
   * GET请求
   *
   * @param url 地址
   * @param params 参数
   * @param checkResult 是否检查 code：1000 和 登录异常 结果  默认true
   */
  get(url, params = {}, cacheParams = false) {
    let cache = false;
    let cacheAge;
    if (cacheParams === true) {
      cache = true;
    } else {
      if (cacheParams.cache === true) {
        cache = true;
      }
      if (cacheParams.cacheAge > 0) {
        cacheAge = cacheParams.cacheAge;
      }
    }

    return axios
      .get(url, { params: params, cache, cacheAge })
      .then(checkResultMap(true));
  },

  /**
   * POST请求
   *
   * @param url 地址
   * @param params 参数
   * @param checkResult 是否检查 code：1000 和 登录异常 结果  默认true
   */
  post(url, params, checkResult = true) {
    return axios
      .post(url, params, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(checkResultMap(checkResult));
  },

  /**
   * DELETE请求
   *
   * @param url 地址
   * @param params 参数
   * @param checkResult 是否检查 code：1000 和 登录异常 结果  默认true
   */
  delete(url, params, checkResult = true) {
    return axios.delete(url, params).then(checkResultMap(checkResult));
  },

  /**
   * PUT请求
   *
   * @param url 地址
   * @param params 参数
   * @param checkResult 是否检查 code：1000 和 登录异常 结果  默认true
   */
  put(url, params, checkResult = true) {
    return axios.put(url, params).then(checkResultMap(checkResult));
  },

  /**
   * multipart 上传
   *
   * @param url 地址
   * @param data 数据
   * @param checkResult 是否检查 code：1000 和 登录异常 结果  默认true
   */
  upload(url, data, checkResult = true) {
    return axios({
      url: url,
      method: "post",
      data: data,
      headers: { "Content-Type": "multipart/form-data" }
    }).then(checkResultMap(checkResult));
  },

  merge([...request]) {
    return axios.all(request).then(
      axios.spread((...result) => {
        return Promise.resolve(result);
      })
    );
  },

  request(params) {
    return axios(params).then(checkResultMap(true));
  }
};
